import React from "react";
import { useAuth } from "../AuthProvider";
import ClientSelector from "../ClientSelector";

const requiresClient = Component => props => {
  const [{ user }, { setSelectedClient }] = useAuth();
  const { selectedClient } = user.preferences;
  if (selectedClient) {
    return <Component {...props} />;
  }

  return (
    <ClientSelector
      onSelect={clientId =>
        setSelectedClient(
          user.clients.find(client => `${client.id}` === clientId)
        )
      }
    />
  );
};

export default requiresClient;
